export default __webpack_public_path__ + "media/avatars/02-43b33335.png";